import React, { useContext } from 'react';
import styles from './AddressCard.module.scss';
import { SFBlue, SFCard, SFIcon, SFText } from 'sfui';
import { AppearanceContext } from 'ui-smartforce-settings';

export interface AddressCardProps {
  className?: string;
  address?: string;
  areas?: string[];
}

export const AddressCard = ({
  className = '',
  address,
  areas
}: AddressCardProps): React.ReactElement<AddressCardProps> => {
  const { themeType } = useContext(AppearanceContext);

  return (
    <SFCard
      className={`${styles.addressCard} ${className}`}
      containerClassName={styles.addressCardContainer}
      sfElevation={1}
    >
      <SFIcon
        icon="Loction-1"
        size={20}
        color={themeType === 'day' ? SFBlue[400] : SFBlue[300]}
      />
      <div className={styles.info}>
        <SFText type="component-3-medium">{address}</SFText>
        {areas && areas.length > 0 ? (
          <SFText type="component-messages" sfColor="neutral">
            {areas.join(', ')}
          </SFText>
        ) : undefined}
      </div>
    </SFCard>
  );
};
